import {gsap} from "gsap";

let bgVideo = promokit.video({
    el: '#bg-video',
    url: 'https://vod.plaync.com/BS/update/201113/index_bg2.mp4',
    loop: true,
    autoplay: true,
    preload: true
});


const mountAnimation = gsap.timeline({paused: true})
    .addLabel('start')
    .from('.title', {opacity: 0, scale: 0.7, duration: .5}, 'start+=1.0')
    .from('.txt', {opacity: 0, y: '+=50', duration: .4}, 'start+=1.3')
    .staggerFrom('.quick-menu a', 0.6, {y: '+=30', opacity:0, rotation: 0, ease: "power2.out",}, 0.1, 'start+=2.0')
    .from('.women', {opacity: 0, x: '+=200', duration: 1.5, ease: 'power2.out'}, 'start+=2.6')
    .from('.bottom-menu', {opacity: 0, y: '+=30', duration: .6}, 'start+=2.8')
    .staggerFrom('.right-menu li', 0.8, {x: '+=150', opacity:0, rotation: 0, ease: "power2.out",}, 0.1, 'start+=3.2')
    .from('.scroll', {opacity: 0, duration: .6}, 'start+=4')


$('.btn-scroll').on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top}, 500, 'linear');
});



export default {
    id: '#section-header',
    backgroundVideo: bgVideo,
    enterStart() {
        mountAnimation.play();
    }
};



// WEBPACK FOOTER //
// ./src/js/section/section1.js